import createReactComponent from '../createReactComponent';
export default createReactComponent('mobile-signal-five', 'MobileSignalFive', [["path",{"d":"M3 21v-1m18 1V3m-9 18v-9m4.5 9V8m-9 13v-5","key":"svg-0"}]]);